import { useEffect } from 'react';

// const BrazeApiKey = getConfig().publicRuntimeConfig.brazeApiKey as string;
// const BrazeSdkEndpoint = 'sdk.fra-02.braze.eu';

export const useBraze = () => {
  // const [_braze, setBraze] = useState<typeof braze>(null);
  // const user = useAuth(s => s.user, shallow);

  // useEffect(() => {
  //   if (!checkIsBrowser()) return;
  //   if (!!braze) return;
  //   // if (!!_braze || !user?.token) return;
  //   // if (!user?.token) return;

  //   // if (braze.isPushSupported()) {
  //   //   braze.requestPushPermission();
  //   // }

  //   braze.initialize(BrazeApiKey, {
  //     baseUrl: BrazeSdkEndpoint,
  //     serviceWorkerLocation: '/BrazeSDKWorker.js',
  //   });

  //   // optionally show all in-app messages without custom handling
  //   // braze.automaticallyShowInAppMessages();

  //   setBraze(braze);

  //   // braze.subscribeToContentCardsUpdates(function (cards) {
  //   //   // console.log('cards', cards);
  //   //   // cards have been updated
  //   // });
  //   // optionally set the current user's external ID before starting a new session
  //   // you can also call `changeUser` later in the session after the user logs in
  //   // braze.changeUser(user.id.toString());
  //   // braze.getUser().setCustomUserAttribute('firstName', user.firstName);
  //   // braze.getUser().setEmail(user.email);
  //   // braze.getUser().setFirstName(user?.firstName);

  //   // braze.subscribeToInAppMessage(function (inAppMessage) {
  //   // control group messages should always be "shown"
  //   // this will log an impression and not show a visible message
  //   // if (inAppMessage instanceof braze.ControlMessage) {
  //   //   return braze.showInAppMessage(inAppMessage);
  //   // }

  //   // if (inAppMessage instanceof braze.InAppMessage) {
  //   //   const extras = inAppMessage.extras;
  //   //   if (extras) {
  //   //     for (const key in extras) {
  //   //       console.log('key: ' + key + ', value: ' + extras[key]);
  //   //     }
  //   //   }
  //   // }
  //   //   braze.showInAppMessage(inAppMessage);
  //   // });

  //   // `openSession` should be called last - after `changeUser` and `automaticallyShowInAppMessages`
  //   // braze.openSession();

  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [_braze, user]);

  useEffect(() => {
    // Ensure this code only runs in the browser environment
    if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
      console.log('Attempting to register Braze Service Worker...');
      navigator.serviceWorker
        .register('/BrazeSDKWorker.js') // Path must match public/
        .then(registration => {
          console.log(
            'Braze Service Worker (standalone) registered successfully with scope:',
            registration.scope
          );
          // At this point, the service worker is active.
          // It will handle push messages sent from Braze.

          // --- IMPORTANT: What's missing with this approach ---
          // 1. **Push Permission Prompt:** The Braze SDK (which you're not using)
          //    normally handles prompting the user for push notification permission.
          //    With this "SW-only" approach, you must implement your own UI and
          //    logic to call `Notification.requestPermission()`.
          // 2. **User Identification:** The service worker itself doesn't know
          //    which Braze user ID it belongs to. You would need to
          //    send the browser's push subscription details (endpoint, keys)
          //    to your *backend server*, which then uses the Braze REST API
          //    to associate that subscription with a Braze user ID.
          //    This means your backend is responsible for all user-to-push-token mapping.
          // 3. **Other Braze Features:** As mentioned, no in-app messages, content cards,
          //    event tracking, or user attribute setting from the client-side.
        })
        .catch(error => {
          console.error('Braze Service Worker (standalone) registration failed:', error);
        });
    } else {
      console.warn(
        'Service Workers are not supported or not running in a browser environment.'
      );
    }
  }, []); // Empty dependency array means this runs once after the first render

  return {};
};
